import { render } from "./ProfileTemplateEdit.vue?vue&type=template&id=7b6bb10f"
import script from "./ProfileTemplateEdit.vue?vue&type=script&lang=js"
export * from "./ProfileTemplateEdit.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__